var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.openEdit)?_c('EditUnit',{attrs:{"unitId":_vm.unitSelect},on:{"close":_vm.closeUnit}}):_vm._e(),(!_vm.openEdit)?_c('UnitsByConfigPull',{on:{"selectUnit":_vm.openUnit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }